import React from 'react';
import MetricCard from './MetricCard';

import NumberSalesIcon from '../../../assets/number-sales-icon.svg';
import TotalSaleIcon from '../../../assets/total-sale-icon.svg';
import NetProfitIcon from '../../../assets/net-profit-icon.svg';
import UnpaidCustomersIcon from '../../../assets/unpaid-customers-icon.svg';

const SalesMetrics = ({ metrics, showProfits, setShowProfits, showTotalSale, setShowTotalSale }) => {
  const metricCards = [
    {
      title: 'Number of Sales',
      value: metrics.totalSales,
      change: metrics.salesChange,
      changeType: metrics.salesChange >= 0 ? 'positive' : 'negative',
      icon: NumberSalesIcon,
      iconColor: 'blue'
    },
    {
      title: 'Total Sale',
      value: `€${metrics.totalAmount.toFixed(2)}`,
      change: metrics.amountChange,
      changeType: metrics.amountChange >= 0 ? 'positive' : 'negative',
      icon: TotalSaleIcon,
      iconColor: 'green',
      showValue: true,
      isVisible: showTotalSale,
      onToggle: () => {
        setShowTotalSale(!showTotalSale);
      }
    },
    {
      title: 'Net Profit',
      value: `€${metrics.netProfit.toFixed(2)}`,
      change: metrics.profitChange,
      changeType: metrics.profitChange >= 0 ? 'positive' : 'negative',
      icon: NetProfitIcon,
      iconColor: 'green',
      showValue: true,
      isVisible: showProfits,
      onToggle: () => {
        setShowProfits(!showProfits);
      }
    },
    {
      title: 'Unpaid Customers',
      value: metrics.unpaidCustomers,
      change: metrics.unpaidChange,
      changeType: metrics.unpaidChange >= 0 ? 'negative' : 'positive',
      icon: UnpaidCustomersIcon,
      iconColor: 'red'
    }
  ];

  return (
    <div className="sales-metrics">
      {metricCards.map((metric, index) => (
        <MetricCard key={index} {...metric} />
      ))}
    </div>
  );
};

export default SalesMetrics;